<template>
<div class="chapter">
<div class="inner_page">
<div class="pgmonospaced">
<br class="calibre1"/>
</div>
<h1 class="calibre2" id="pgepubid00000">THE FIFTH BATTALION<br class="calibre3"/>
  HIGHLAND LIGHT INFANTRY<br class="calibre3"/>
  IN THE WAR</h1>
<h3 class="sigilnotintoc sigil_not_in_toc" id="pgepubid00001">1914-1918</h3>
<p class="center"><img alt="morrison" class="calibre4" src="Images/img00001.jpg"/> <a id="illus01"></a></p>
<p class="center">COLONEL F.L. MORRISON, C.B., D.S.O., V.D.</p>
<h3 class="sigilnotintoc sigil_not_in_toc" id="pgepubid00002">The Fifth Battalion</h3>
<h2 class="sigilnotintoc1 sigil_not_in_toc" id="pgepubid00003">Highland Light Infantry<br class="calibre3"/>
  in the War</h2>
<h4 class="sigilnotintoc2 sigil_not_in_toc" id="pgepubid00004">1914-1918</h4>
<p class="center">TO THE MEMORY OF</p>
<p class="center">THE OFFICERS, WARRANT OFFICERS,</p>
<p class="center">NON-COMMISSIONED OFFICERS AND MEN OF</p>
<p class="center">THE FIFTH BATTALION HIGHLAND LIGHT INFANTRY</p>
<p class="center">WHO FELL IN THE WAR 1914-1918</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?20561706